import React from 'react'
import { PulseLoader } from 'react-spinners'

const Loading = () => {
  return (
    <div className='loader-container'>
      <PulseLoader />
    </div>
  )
}

export default Loading